import React from 'react';

import { AccountMenuLoggedOutStateNav4 } from '../account-menu-logged-out-state/nav4';
import { AccountMenuTriggerNav4 } from '../account-menu-popup/account-menu-trigger/nav4';

import { AccountMenu, type AccountMenuProps } from './index';

export const AccountMenuNav4 = (props: AccountMenuProps): React.JSX.Element => {
	return (
		<AccountMenu
			{...props}
			AccountMenuLoggedOutState={AccountMenuLoggedOutStateNav4}
			AccountMenuTrigger={AccountMenuTriggerNav4}
		/>
	);
};
